<div style="text-align: center;"  [ngStyle]="customService.getLoadingTextStyle()">
    <h1 mat-dialog-title>{{data.title}}</h1>
    <div mat-dialog-content>
      <p style="word-wrap: break-word;"> {{data.message}}</p>
    </div>
</div>
